import _ from 'lodash'

/**
 *
 * @param {array} addons an array of addons
 */
export default function groupCartLineAddonsWithQuantity(addons = []) {
  const uniqAddons = _.uniqWith(addons, (a, b) => (
    _.isEqual(_.get(a, 'sku.id', 'a'), _.get(b, 'sku.id', 'b'))
    && _.isEqual(_.get(a, 'parentIdentifierUuid', 'a'), _.get(b, 'parentIdentifierUuid', 'b'))
  ))
  const addonsWithQuantity = _.map(uniqAddons, (addon) => {
    const items = _.filter(addons, (item) => (
      _.isEqual(_.get(addon, 'sku.id', 'a'), _.get(item, 'sku.id', 'b'))
      && _.isEqual(_.get(addon, 'parentIdentifierUuid', 'a'), _.get(item, 'parentIdentifierUuid', 'b'))
    ))
    const itemCount = _.sumBy(items, 'quantity')
    return {
      ...addon,
      quantity: itemCount,
    }
  })
  return addonsWithQuantity
}
